var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _g2, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 168 118",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Person") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0Person",
    d: "m48.7 111.6h-13.1v-3.4-6.7c0-0.7 0.3-4 0.4-4.9 1.1-5 3.4-10 6.7-14 4.8-5.9 13.1-10.3 20.6-11.2 0.2 0-5 3.9-7.9 7.9-2.1 2.9-3 4.1-4.6 7.7-1.9 3.9-2.6 12.1-2.1 24.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1Person",
    d: "m101.8 67.8l-0.4-0.1c-0.2-0.1-0.5-0.1-0.7 0h-0.2l-4.9-0.2 3.3-3.2c4.5-4.4 7-10.4 7-16.7v-36.3c0-0.9-0.7-1.6-1.6-1.6h-26.8c-9.9 0-18 8.2-18 18.2v19.6c0 6.3 2.5 12.3 7 16.7l3.3 3.3-5 0.2h-0.2-0.2c-0.2 0-0.3 0-0.4 0.1l-0.4 0.1c-17.8 1.5-31.6 16.7-31.6 34.6v11.1c0 0.9 0.7 1.6 1.6 1.6h68.4c0.9 0 1.7-0.8 1.7-1.6s-0.8-1.6-1.7-1.6h-66.8v-5.6l0.2-7.5c1.7-14.5 13-25.9 27.4-27.6l1-0.1 17.7 17.8c0.6 0.6 1.7 0.6 2.3 0l17.7-18 1 0.1c15.8 1.9 27.6 15.4 27.6 31.4v9.4h-20.5c-0.9 0-1.7 0.8-1.7 1.6s0.8 1.6 1.7 1.6h22.2c0.9 0 1.6-0.7 1.6-1.6v-11.1c-0.1-17.8-13.9-33-31.6-34.6zm-39.1-39.9c0-8.2 6.6-14.9 14.8-14.9h25.1v11.7c0 6-4.9 10.9-10.9 10.9h-29v-7.7zm0 19.6v-8.7h29.1c2.8 0 5.4-0.8 7.7-2.3l3.1-2.1v13.1c0 11.1-9 20.1-20 20.1s-19.9-9-19.9-20.1zm19.9 37.9l-14.3-14.5h28.7l-14.4 14.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1Person",
    d: "m92.5 91.5c1.4 0 2.6 1.1 2.6 2.6 0 1.4-1.1 2.6-2.6 2.6-1.4 0-2.6-1.1-2.6-2.6s1.2-2.6 2.6-2.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2Person",
    d: "m66.4 23.9c0.7 0 1.3 0.6 1.3 1.3v7.7c0 0.7-0.6 1.3-1.3 1.3s-1.3-0.6-1.3-1.3v-7.7c0-0.7 0.6-1.3 1.3-1.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.108 7.6957)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1Person",
    d: "M4.9,5.8C4.4,5.8,4,6.2,4,6.6v1.9C4,9,4.4,9.4,4.9,9.4S5.7,9,5.7,8.6v-2C5.7,6.2,5.3,5.8,4.9,5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1Person",
    d: "m2.7 3.9h-1.9c-0.4 0-0.8 0.4-0.8 0.8 0 0.5 0.4 0.8 0.8 0.8h1.9c0.5 0 0.8-0.4 0.8-0.8s-0.3-0.8-0.8-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1Person",
    d: "M4.9,0C4.4,0,4,0.4,4,0.8v1.9c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8V0.8   C5.7,0.4,5.3,0,4.9,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1Person",
    d: "M8.9,3.8H7c-0.5,0-0.8,0.4-0.8,0.8c0,0.5,0.4,0.8,0.8,0.8h1.9c0.5,0,0.8-0.4,0.8-0.8   S9.4,3.8,8.9,3.8"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1Person",
    d: "m8.2 83.8s1.1 8-8.2 7.8c0 0 8 0.1 7.8 7.6 0 0 0.7-5.9 8.1-7.2 0-0.1-6.3 1.4-7.7-8.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3Person",
    d: "m125.5 44.5s1.1 8-8.2 7.8c0 0 8 0.1 7.8 7.6 0 0 0.7-5.9 8.1-7.2 0-0.1-6.2 1.3-7.7-8.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1Person",
    d: "m26.8 54.7s0.4 2.8-2.9 2.7c0 0 2.8 0 2.7 2.6 0 0 0.3-2 2.8-2.5 0.1 0.1-2.1 0.6-2.6-2.8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4Person",
    d: "m125 5.2c-1.4 0-2.6-1.2-2.6-2.6s1.2-2.6 2.6-2.6 2.6 1.2 2.6 2.6-1.2 2.6-2.6 2.6zm0-4.2c-0.9 0-1.6 0.7-1.6 1.6s0.7 1.6 1.6 1.6 1.6-0.7 1.6-1.6-0.7-1.6-1.6-1.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4Person",
    d: "m5.6 28.2c-1.2 0-2.1-0.9-2.1-2.1s0.9-2.1 2.1-2.1 2.1 0.9 2.1 2.1-0.9 2.1-2.1 2.1zm0-3.2c-0.6 0-1.1 0.5-1.1 1.1s0.5 1.1 1.1 1.1 1.1-0.5 1.1-1.1-0.5-1.1-1.1-1.1z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150.73 80.377)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1Person",
    d: "m8.1 10.3c-0.7 0-1.3 0.6-1.3 1.4v3.2c0 0.8 0.6 1.4 1.3 1.4s1.3-0.6 1.3-1.4v-3.2c0-0.8-0.6-1.4-1.3-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1Person",
    d: "M4.6,6.8H1.4C0.6,6.8,0,7.4,0,8.1s0.6,1.3,1.4,1.3h3.2C5.4,9.4,6,8.8,6,8.1S5.4,6.8,4.6,6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1Person",
    d: "M8.1,0C7.4,0,6.9,0.6,6.9,1.4v3.2C6.9,5.4,7.4,6,8.1,6s1.3-0.6,1.3-1.4V1.4   C9.4,0.6,8.8,0,8.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1Person",
    d: "m14.9 6.8h-3.2c-0.8 0-1.4 0.6-1.4 1.3s0.6 1.3 1.4 1.3h3.2c0.8 0 1.4-0.6 1.4-1.3s-0.6-1.3-1.4-1.3"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0Person",
    d: "M77.5,13c-8.2,0-14.8,6.7-14.8,14.9v7.7h29.1c6,0,10.9-4.9,10.9-10.9V13H77.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0Person",
    d: "m62.7 38.9v8.7c0 10.8 8.5 19.6 19.2 20.1-5.8-2.1-11.5-7.8-11.5-13.3v-15.5h-7.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/Customer.853412ea8f69eebfe31276cd129e1bfc.svg";
export { ForwardRef as ReactComponent };